import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseurl } from '../utility/helper';
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import '../assets/css/Spotlight.css';



function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button className="slick-prev" onClick={onClick}>
      Previous
    </button>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <button className="slick-next" onClick={onClick}>
      Next
    </button>
  );
}

const Spotlight = () => {
  const Member_count = sessionStorage.getItem("members_in_india");
  const mid = parseInt(sessionStorage.getItem("MemberID")) || null;
  const isLoggedIn = Boolean(mid);
  const navigate = useNavigate();
  const [magazines, setMagazines] = useState([]);
  const [newsEvents, setNewsEvents] = useState([]);
  const location = useLocation();
  const { state } = location || {};
  const defaultTab = state?.tab || "#one"; 

  useEffect(() => {
        if (defaultTab) {
          // Simulate a click to open correct tab
          const tabElement = document.querySelector(`a[href="${defaultTab}"]`);
          if (tabElement) {
            tabElement.click();
          }
        }
      }, [defaultTab]);
  useEffect(() => {
    axios.get(`${baseurl}/news-events`)
        .then(response => setNewsEvents(response.data))
        .catch(error => console.error("Error fetching news:", error));
  }, []);
  useEffect(() => {
    axios.get(`${baseurl}/magazines`)
      .then(res => setMagazines(res.data))
      .catch(err => console.error(err));
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const bufferToBase64 = (buffer) => {
    if (!buffer || !buffer.data) return null;
    const binary = new Uint8Array(buffer.data).reduce(
      (acc, byte) => acc + String.fromCharCode(byte),
      ''
    );
    return `data:image/png;base64,${btoa(binary)}`;
  };

  const handleViewPDF = async (id) => {
  try {
    const res = await axios.get(`${baseurl}/magazines/download?id=${id}`);
    const files = res.data.files;

    files.forEach(file => {
      const link = document.createElement("a");
      link.href = file.url;     // presigned URL
      link.download = file.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  } catch (err) {
    console.error(err);
    alert("Failed to download PDF");
  }
};

const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

  return (
<div className='bacimage'>
    <section className="banner">
  <Slider {...settings}>

    {/* Slide 1 - Clean Image */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Banner 1" />
       <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

    {/* Slide 2 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner3.png" alt="Social Impact" />
      <div className="hero-content">
        <h1 className="hero-title">
          SOCIAL IMPACT
          <br />
          DHRUV &amp; TMNP
        </h1>
       
        <div className="hero-actions">
          <NavLink to="/Spotlight" className="hero-btn hero-btn--primary"> Click Here</NavLink>
        </div>
      </div>
    </div>

    {/* Slide 3 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Our Mission" />
      <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

  </Slider>
</section>


    <div className="event" style={{marginTop:'20px'}}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="wow fadeInDown animated" data-animation="fadeInDown animated" data-delay=".2s"
               style={{ visibility: 'visible', animationName: 'fadeInDown' }}>

            <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
              <a className="nav-item nav-link active show" id="nav-home-tab" data-toggle="tab" href="#one" role="tab"
                 aria-selected="true">
                <div className="nav-content">
                  <strong>Special Projects</strong>
                 
                </div>
              </a>
              <a className="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#two" role="tab"
                 aria-selected="false">
                <div className="nav-content">
                  <strong>News</strong>
                 
                </div>
              </a>
              <a className="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#three" role="tab"
                 aria-selected="false">
                <div className="nav-content">
                  <strong>Magazines</strong>
                 
                </div>
              </a>
              
            </div>

          </nav>
          </div>
          </div>

          <div className="row">
          <div className="col-lg-12 col-md-12">
          <div className="tab-content wow fadeInDown animated"
                data-animation="fadeInDown animated" data-delay=".2s" id="nav-tabContent"
                style={{ visibility: 'visible', animationName: 'fadeInDown' }}>
      <div className="tab-pane fade active show" id="one" role="tabpanel" aria-labelledby="nav-home-tab">
      <section id="about" className="about">
    <div className="container" style={{padding:'0px'}}>
      <section id="team" className="team" style={{padding:'0px'}}>
      <div className="container" style={{padding:'0px'}}>

        <div className="section-title" data-aos="fade-up">
          {/* <h2> MENSA INDIA HQ </h2> */}
          <p></p>
        </div>

        <div className="row">

      <Slider {...settings2}>

          {/* Window 1 - Kishore Asthana */}
          <div className="">
            <div className="member" data-aos="zoom-in">
              <div className="pic">
                <img src="assets/img/team/Kishore_Asthana.jpeg" alt="Kishore Asthana" style={{ width: "60%", height: "200px", objectFit: "cover", borderRadius: "10%" }}></img>
              </div>
              <div className="member-info">
                <h4>Kishore Asthana</h4>
                <span>President</span>
                <a
                  href="https://www.mensaprojectdhruv.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary mt-2"
                >
                  Project Dhruv
                </a>
              </div>
            </div>
          </div>

          {/* Window 2 - Narayan Desai */}
          <div className="">
            <div className="member" data-aos="zoom-in" data-aos-delay="100">
              <div className="pic">
                <img src="assets/img/team/Narayan_desai.jpeg" alt="Dr. Narayan Desai" style={{ width: "60%", height: "200px", objectFit: "cover", borderRadius: "10%" }}></img>
              </div>
              <div className="member-info">
                <h4>Dr. Narayan Desai</h4>
                <span>President</span>
                <a
                  href="https://www.tribalmensa.org/tmnp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary mt-2"
                >
                  Project TMNP
                </a>
              </div>
            </div>
          </div>

          {/* Window 3 - Gowri Shanker */}
          <div className="">
            <div className="member" data-aos="zoom-in" data-aos-delay="200">
              <div className="pic">
                <img src="assets/img/team/Gowri_Shanker.jpeg" alt="Gowri Shanker" style={{ width: "60%", height: "200px", objectFit: "cover", borderRadius: "10%" }}></img>
              </div>
              <div className="member-info">
                <h4>Gowri Shanker</h4>
                <span>President</span>
                <a
                  href="mailto:dhruvtamilnadu@mensaindia.org"
                  className="btn btn-primary mt-2"
                >
                  Project Dhruv-Tamilnadu
                </a>
              </div>
            </div>
          </div>

        </Slider>
        </div>

      </div>
    </section>

    </div>
    <br></br>
  </section>
      </div>
    
      <div className="tab-pane fade" id="two" role="tabpanel" aria-labelledby="nav-profile-tab">
      <section className="section">
        <div className="container">
            <div className="justify-content-center row">
                <div className="col-lg-12">
                    <div className="candidate-list-widgets mb-4">
                        {/* <form action="#"> */}
                            {/* <div className="g-2 row"> */}
                            {newsEvents.map((event, index) => (
                                <div className="event-list" key={index}>
                                    <div className="member" data-aos="zoom-in">
                                        <div className="pic">
                                            <img 
                                                src={bufferToBase64(event.main_image) || "assets/img/portfolio/portfolio-1.jpg"}
                                                className="img-fluid" 
                                                width={300}
                                                alt={event.title} 
                                                style={{height:'200px', objectFit:'contain'}}
                                            />
                                        </div>
                                        <div className="event-info">
                                            <h4>{event.title}</h4>
                                            <p style={{fontSize: 14}}>{event.short_desc}</p>
                                            <a href="#" className="read-more">Read more &gt;</a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* </div> */}
                        {/* </form> */}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="align-items-center row">
                        
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>

    <div className="tab-pane fade" id="three" role="tabpanel" aria-labelledby="nav-profile-tab">
      <section className="section">
        <div className="container">
            <div className="justify-content-center row">
                <div className="col-lg-12">
                    <div className="container">
                      <div className="section-title" data-aos="fade-up" style={{ paddingBottom: '1px' }}>
                        <h2>MInd Magazine</h2>
                      </div>

                      <div className="row">
                        {magazines && magazines.length > 0 ? (
                          magazines.map((magazine) => (
                            <div key={magazine.id} className="col-lg-4 mb-4" data-aos="fade-left">
                              <div className="content p-3 border rounded" style={{ background: '#f9f9f9' }}>
                                <h3>{magazine.heading}</h3>
                                <p className="font-italic">{magazine.short_desc}</p>
                                <ul>
                                  {/* <li> */}
                                    <i className="icofont-check-circled"></i> {magazine.long_desc}
                                  {/* </li> */}
                                </ul>
                                <br />
                                {(() => {
                                  try {
                                    const files = JSON.parse(magazine.attachment_url || "[]");
                                    return files.length > 0 ? (
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => handleViewPDF(magazine.id)}
                                      >
                                        View
                                      </button>
                                    ) : null;
                                  } catch {
                                    return null;
                                  }
                                })()}
                                <p>{formatDateTime(magazine.created_at)}</p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>Not Found MInd-Magazines...</p>
                        )}
                      </div>
                    </div>
                </div>
            </div>
        </div>
       {isLoggedIn && (
  <>
    <center>
      <b>
        Please send your submissions to{" "}
        <a href="mailto:editor@mensaindia.org">
          editor@mensaindia.org
        </a>
      </b>
    </center>

    <center>
      <b>Submit Content & Articles for MInd
      <a href="https://form.jotform.com/252154898331462" target="_blank" rel="noopener noreferrer"> Click Here</a></b>
    </center>

    <center>
      <b>Submit Feedback for MInd Magazine
      <a href="https://form.jotform.com/260991325107456" target="_blank" rel="noopener noreferrer"> Click Here</a></b>
    </center>
  </>
)}


      
    </section>
    </div>

    </div>
        </div>
      </div>
    </div>

    </div>

    </div>
  );
};

  

 


export default Spotlight;
